export default "__VITE_ASSET__DLlrfRet__"